interface OrnamentSeparatorProps {
  className?: string;
}

function OrnamentSeparator({ className = '' }: OrnamentSeparatorProps) {
  return (
    <div className={`flex items-center justify-center gap-3 text-parchment-400 my-4 ${className}`}>
      <div className="h-px flex-1 max-w-16 bg-gradient-to-r from-transparent to-parchment-400" />
      <span className="text-base tracking-widest">&#9830;</span>
      <div className="h-px flex-1 max-w-16 bg-gradient-to-l from-transparent to-parchment-400" />
    </div>
  );
}

export default OrnamentSeparator;
